import { AxiosInstance } from "axios";
import axios from "axios";

export class StreamingClient {
	private instance: AxiosInstance;
	private baseUrl: string;
	protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
		undefined;

	constructor(baseUrl?: string, instance?: AxiosInstance) {
		this.instance = instance ? instance : axios.create();
		this.baseUrl =
			baseUrl !== undefined && baseUrl !== null
				? baseUrl
				: "http://host.docker.internal:55002";
	}

	async *streamApiResponseForObjects<T>(
		url: string,
		method: "GET" | "POST" = "GET",
		payload?: any
	): AsyncGenerator<T, void, unknown> {
		let url_ = this.baseUrl + url;
		url_ = url_.replace(/[?&]$/, "");

		const response = await fetch(url_, {
			method: method,
			headers: {
				"Content-Type": "application/json",
			},
			body: payload ? JSON.stringify(payload) : undefined,
		});

		if (!response.body) {
			throw new Error("Response body is not a ReadableStream.");
		}

		const reader = response.body.getReader();
		const decoder = new TextDecoder();
		let buffer = "";

		try {
			while (true) {
				const { value, done } = await reader.read();
				if (done) {
					break;
				}

				buffer += decoder.decode(value, { stream: true });

				// Extract complete JSON objects using brace depth tracking
				let startIndex = buffer.indexOf("{");
				while (startIndex !== -1) {
					let depth = 0;
					let endIndex = -1;
					let inString = false;
					let escape = false;

					for (let i = startIndex; i < buffer.length; i++) {
						const ch = buffer[i];
						if (escape) {
							escape = false;
							continue;
						}
						if (ch === "\\" && inString) {
							escape = true;
							continue;
						}
						if (ch === '"') {
							inString = !inString;
							continue;
						}
						if (inString) continue;
						if (ch === "{") depth++;
						else if (ch === "}") {
							depth--;
							if (depth === 0) {
								endIndex = i;
								break;
							}
						}
					}

					if (endIndex === -1) break;

					const objectStr = buffer.substring(startIndex, endIndex + 1);
					buffer = buffer.substring(endIndex + 1);
					yield JSON.parse(objectStr) as T;
					startIndex = buffer.indexOf("{");
				}
			}
		} finally {
			reader.releaseLock();
		}
	}

	async *streamApiResponseForArray(
		url: string,
		method: "GET" | "POST" = "GET",
		payload?: any
	): AsyncGenerator<string, void, unknown> {
		let url_ = this.baseUrl + url;
		url_ = url_.replace(/[?&]$/, "");

		const response = await fetch(url_, {
			method: method,
			headers: {
				"Content-Type": "application/json",
			},
			body: payload ? JSON.stringify(payload) : undefined,
		});

		if (!response.body) {
			throw new Error("Response body is not a ReadableStream.");
		}

		const reader = response.body.getReader();
		const decoder = new TextDecoder();
		let buffer = "";

		try {
			while (true) {
				const { value, done } = await reader.read();
				if (done) {
					break;
				}

				buffer += decoder.decode(value, { stream: true });

				// Process complete lines/chunks if your API sends data line-by-line (e.g., NDJSON)
				let separatorIndex;
				while ((separatorIndex = buffer.indexOf(",")) !== -1) {
					let line = buffer.substring(0, separatorIndex).trim();
					buffer = buffer.substring(separatorIndex + 1);
					if (line) {
						// Yield only non-empty lines
						line = line.replace(/^\[/, "");
						yield line;
					}
				}
				separatorIndex = null;
			}

			// Yield any remaining data in the buffer after the stream ends
			if (buffer.trim()) {
				yield buffer.trim().replace(/\]$/g, "");
			}
			buffer = "";
		} finally {
			reader.releaseLock();
		}
	}
}

export default StreamingClient;
